module.exports = __webpack_public_path__ + "img/EmilyMandin.9deb0108.jpg";